// extracted by css-extract-rspack-plugin
export default {"widget":"z2F5v"};